import React, { Component } from 'react';
import axios from '../../axios';
import qs from 'qs';
import Alert from 'react-s-alert'
import CardSaldo from '../../components/CardSaldo'
import { connect } from 'react-redux'

class Forms extends Component {
    constructor(props) {
        super(props)

        this.state = {
            id_penagihan: 0,
            nominal_penagihan: 0,
            isButtonLoading: props.mode === 'Edit' ? true : false,
            isLoading: props.mode === 'Edit' ? true : false,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    handleSubmit() {

        this.setState({isButtonLoading: true})

        if (this.state.nominal_penagihan > this.props.jumlah_saldo) {

            Alert.error("Nominal yang anda masukkan tidak dapat melebihi sisa saldo!");

            this.setState({isButtonLoading: false})

            return;
        }

        const aksi = this.props.mode === "Edit" ? "updatePenagihan/" + this.state.id_penagihan : "savePenagihan"

        axios({
            method: 'post',
            url: '/penagihan/' + aksi,
            data: qs.stringify(this.state)
        })
            .then(response => {

                const result = response.data;

                if (result.status !== 1) {

                    result.msg.map((item) => {
                        Alert.error(item)

                        return true
                    })

                    this.setState({isButtonLoading: false})
                }
                else {
                    Alert.success(result.msg)
                    this.props.history.replace("/penagihan");
                }

                return;
            })
            .catch(error => {
                console.log(error)
                this.setState({isButtonLoading: false})
                Alert.error("Gagal terhubung ke server!")
            })

    }

    componentDidMount() {

        if (this.props.mode === 'Edit') {

            axios({
                method: 'get',
                url: '/penagihan/getPenagihan/' + this.props.match.params.id_penagihan
            })
                .then(response => {

                    const result = response.data;

                    this.setState({
                        id_penagihan: result.id_penagihan,
                        nominal_penagihan: result.nominal_penagihan,
                        isButtonLoading: false,
                        isLoading: false,
                    })

                    return;
                })
                .catch(error => {
                    console.log(error)
                    this.setState({isLoading: false})
                    Alert.error("Gagal terhubung ke server!")
                })
        }
    }

    render() {

        return (
            <div className="col-sm-12">
                <CardSaldo />
                <div className="card">
                    <div className="card-header">
                        {this.props.mode} Request Penagihan
                    </div>
                    <div className="card-block">
                        {
                            this.state.isLoading ? 'Memuat Data...' : (
                                <div className="form-horizontal animated fadeIn">
                                    <div className="form-group row">
                                        <label className="col-md-2 form-control-label">Nominal Penagihan</label>
                                        <div className="col-md-10">
                                            <div className="input-group">
                                                <span className="input-group-addon">Rp </span>
                                                <input
                                                    name="nominal_penagihan"
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Masukkan nominal penagihan"
                                                    onChange={this.handleChange}
                                                    value={this.state.nominal_penagihan} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div className="card-footer">
                        <button
                            type="button"
                            className="btn btn-md btn-primary"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={this.handleSubmit}
                        >
                            {this.state.isButtonLoading ? "Loading" : "Simpan"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    jumlah_saldo: state.saldoReducer.jumlah_saldo
})

export default connect(mapStateToProps)(Forms);


// WEBPACK FOOTER //
// ./src/views/Penagihan/Forms.js